export default __webpack_public_path__ + "static/media/backBlack.99584993.svg";